var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 129,
    viewBox: "0 0 156 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 22.1C15.6 15.4726 20.9726 10.1 27.6 10.1H47.599C61.0727 10.1 62.7569 22.1 79.599 22.1H128.4C135.027 22.1 140.4 27.4726 140.4 34.1V104.5C140.4 111.127 135.027 116.5 128.4 116.5H27.6C20.9726 116.5 15.6 111.127 15.6 104.5V22.1Z",
    fill: "#52AFE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 22.1C15.6 15.4726 20.9726 10.1 27.6 10.1H47.599C61.0727 10.1 62.7569 22.1 79.599 22.1H128.4C135.027 22.1 140.4 27.4726 140.4 34.1V104.5C140.4 111.127 135.027 116.5 128.4 116.5H27.6C20.9726 116.5 15.6 111.127 15.6 104.5V22.1Z",
    fill: "url(#paint0_linear_950_980)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_950_980",
    x1: 77.999,
    y1: 28.5,
    x2: 77.999,
    y2: 52.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00529E",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBack);
export default __webpack_public_path__ + "static/media/folder-back.06b2bd800647e9136b6d3d4ca46b4a43.svg";
export { ForwardRef as ReactComponent };